var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpcomingEventsLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 52.4999V47.4999C42.5 44.8478 41.4464 42.3042 39.5711 40.4289C37.6957 38.5535 35.1522 37.4999 32.5 37.4999H12.5C9.84783 37.4999 7.3043 38.5535 5.42893 40.4289C3.55357 42.3042 2.5 44.8478 2.5 47.4999V52.4999",
    stroke: "#3F7DBC",
    strokeWidth: 4.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27.4999C28.0229 27.4999 32.5 23.0228 32.5 17.4999C32.5 11.9771 28.0229 7.49991 22.5 7.49991C16.9772 7.49991 12.5 11.9771 12.5 17.4999C12.5 23.0228 16.9772 27.4999 22.5 27.4999Z",
    stroke: "#3F7DBC",
    strokeWidth: 4.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 52.4999V47.4999C57.4983 45.2843 56.7609 43.1319 55.4034 41.3807C54.0459 39.6296 52.1453 38.3789 50 37.825",
    stroke: "#3F7DBC",
    strokeWidth: 4.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 7.82492C42.151 8.37567 44.0576 9.62667 45.4191 11.3807C46.7806 13.1347 47.5196 15.292 47.5196 17.5124C47.5196 19.7328 46.7806 21.8901 45.4191 23.6441C44.0576 25.3982 42.151 26.6492 40 27.1999",
    stroke: "#3F7DBC",
    strokeWidth: 4.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingEventsLg);
export default __webpack_public_path__ + "static/media/UpcomingEventsLg.1fc24a31a30f0ce6e197c3c6ecef1094.svg";
export { ForwardRef as ReactComponent };